import { render, staticRenderFns } from "./Himbauan.vue?vue&type=template&id=7c33ba34"
import script from "./Himbauan.vue?vue&type=script&lang=js"
export * from "./Himbauan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports